module.exports = __webpack_public_path__ + "images/a-radchenko_big-339828.jpg";